import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=11e052fc&scoped=true&"
var script = {}
import style0 from "./appFooter.vue?vue&type=style&index=0&id=11e052fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e052fc",
  null
  
)

export default component.exports